<template>
    <GZ-ModalMainTmpl icon="icon-flag">
        <span slot="title">Добавить юридическое лицо</span>
        
        <section slot="content">
            <AddServiceEntityForm />
        </section>
    </GZ-ModalMainTmpl>
</template>

<script>
import AddServiceEntityForm from '@/components/custom/admin/views/service-entity/ServiceEntityAddForm'

export default {
    name: 'AddServiceEntity',

    components: {
        AddServiceEntityForm
    }
}
</script>